import type { TFunction } from 'i18next';
import { NS } from '../U3147';
import type { U3147ManualTimeField, U3147OverlapFieldHint } from './u3147FormatDuration';

export function u3147BuildOverlapFieldMessage(
  field: U3147ManualTimeField,
  hint: U3147OverlapFieldHint,
  t: TFunction,
): string {
  const isDuration = field === 'durationMinutes';

  switch (hint.kind) {
    case 'startBeforeOrAfter':
      return t('msgOverlapStartBeforeOrAfter', {
        ns: NS,
        before: hint.beforeTime,
        after: hint.afterTime,
        defaultValue: `Chevauchement. Début disponible avant ${hint.beforeTime} ou après ${hint.afterTime}.`,
      });
    case 'startBefore':
      return t('msgOverlapStartBefore', {
        ns: NS,
        before: hint.beforeTime,
        defaultValue: `Chevauchement. Début disponible avant ${hint.beforeTime}.`,
      });
    case 'startAfter':
      return t('msgOverlapStartAfter', {
        ns: NS,
        after: hint.afterTime,
        defaultValue: `Chevauchement. Début disponible après ${hint.afterTime}.`,
      });
    case 'endBefore':
      return isDuration
        ? t('msgOverlapDurationBefore', {
            ns: NS,
            before: hint.beforeTime,
            defaultValue: `Chevauchement. Fin disponible avant ${hint.beforeTime} (réduisez la durée).`,
          })
        : t('msgOverlapEndBefore', {
            ns: NS,
            before: hint.beforeTime,
            defaultValue: `Chevauchement. Fin disponible avant ${hint.beforeTime}.`,
          });
    case 'endAfter':
      return isDuration
        ? t('msgOverlapDurationAfter', {
            ns: NS,
            after: hint.afterTime,
            defaultValue: `Chevauchement. Fin disponible après ${hint.afterTime} (augmentez la durée).`,
          })
        : t('msgOverlapEndAfter', {
            ns: NS,
            after: hint.afterTime,
            defaultValue: `Chevauchement. Fin disponible après ${hint.afterTime}.`,
          });
    case 'endBeforeOrAfter':
      return isDuration
        ? t('msgOverlapDurationBeforeOrAfter', {
            ns: NS,
            before: hint.beforeTime,
            after: hint.afterTime,
            defaultValue: `Chevauchement. Fin disponible avant ${hint.beforeTime} ou après ${hint.afterTime} (ajustez la durée).`,
          })
        : t('msgOverlapEndBeforeOrAfter', {
            ns: NS,
            before: hint.beforeTime,
            after: hint.afterTime,
            defaultValue: `Chevauchement. Fin disponible avant ${hint.beforeTime} ou après ${hint.afterTime}.`,
          });
    default:
      return t('msgOverlapWarning', {
        ns: NS,
        defaultValue: 'Chevauchement avec une autre plage du jour.',
      });
  }
}
